(() => {
  document.addEventListener('click', (e) => {
    const a = e.target.closest('a[href^="#"]');
    if (!a) return;

    const hash = a.getAttribute('href');
    if (!hash || hash === '#') return;

    const target = document.querySelector(hash);
    if (!target) return;

    e.preventDefault();

    // ScrollSmoother があるならそれを使う
    const smoother = window.ScrollSmoother?.get?.();
    if (smoother) {
      smoother.scrollTo(target, true, 'top top'); // 第2引数 true がスムース
      return;
    }

    // fallback（ScrollSmoother無いなら通常）
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
})();

(() => {
  // 1回だけイベントを貼る（多重登録防止）
  if (window.__lpFloor201Bound) return;
  window.__lpFloor201Bound = true;

  const waitForGSAP = (cb, maxTry = 60) => {
    let count = 0;
    const timer = setInterval(() => {
      const gsap = window.gsap;
      const ScrollTrigger = window.ScrollTrigger || (gsap && gsap.plugins && gsap.plugins.ScrollTrigger);
      if (gsap && ScrollTrigger) {
        clearInterval(timer);
        cb(gsap, ScrollTrigger);
      } else if (++count >= maxTry) {
        clearInterval(timer);
      }
    }, 100);
  };

  const getNumberAttr = (el, name, fallback) => {
    const v = el.getAttribute(name);
    const n = v == null ? NaN : Number(v);
    return Number.isFinite(n) ? n : fallback;
  };

  const init = (root = document) => {
    // このセクションの parallax 対象だけ取る
    const targets = root.querySelectorAll('.parallax-img');
    if (!targets.length) return;

    waitForGSAP((gsap, ScrollTrigger) => {
      try {
        gsap.registerPlugin(ScrollTrigger);
      } catch (e) {}

      // 既存のScrollTriggerを二重に作らない（要素ごとに紐づくトリガーがあれば殺す）
      targets.forEach((el) => {
        if (el.__lpFloor201Tween) {
          el.__lpFloor201Tween.scrollTrigger && el.__lpFloor201Tween.scrollTrigger.kill();
          el.__lpFloor201Tween.kill();
          el.__lpFloor201Tween = null;
        }
      });

      const mm = gsap.matchMedia();

      mm.add('(min-width: 900px)', () => {
        targets.forEach((el) => {
          const y = getNumberAttr(el, 'data-y', -100);
          el.__lpFloor201Tween = gsap.to(el, {
            y,
            scrollTrigger: {
              trigger: el,
              start: 'top bottom',
              end: 'bottom top',
              scrub: 0.3,
              invalidateOnRefresh: true,
            },
          });
        });
      });

      mm.add('(max-width: 899px)', () => {
        targets.forEach((el) => {
          const defaultY = getNumberAttr(el, 'data-y', -100);
          const mobileY = getNumberAttr(el, 'data-mobile-y', defaultY * 0.5);

          el.__lpFloor201Tween = gsap.to(el, {
            y: mobileY,
            scrollTrigger: {
              trigger: el,
              start: 'top bottom',
              end: 'bottom top',
              scrub: 0.3,
              invalidateOnRefresh: true,
            },
          });
        });
      });

      // lazyload画像で高さが変わるので念のためrefresh
      ScrollTrigger.refresh();
    });
  };

  // 初回ロード
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  } else {
    init(document);
  }

  // Shopifyテーマエディタ等でセクションが差し込まれた時
  document.addEventListener('shopify:section:load', (e) => {
    if (!e || !e.target) return;
    init(e.target);
  });

  // ついでに、ブロック選択などで再描画されるケースにも強くする
  document.addEventListener('shopify:section:reorder', () => init(document));
})();